import React from 'react'
import PreviewerPageWrapper from '@apphiveio/controlsmanager/components/PreviewerPageWrapper'
import splashScreen from './splashScreen.png'

const ClientAppSplashScreen = () => (
  <PreviewerPageWrapper backgroundSource={splashScreen} />
)

export default ClientAppSplashScreen
